import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { useForm } from "react-hook-form"
import { Box, Flex, Stack, useToast } from "@chakra-ui/react"

import GModal from "components/ui/modal/Modal"
import Input from "components/form/Input"
import GButton from "components/ui/button/Button"
import { getRoles, updateRole } from "../../services/rolesService"

const UpdateModal = ({
  data,
  onClose
}) => {
  const toast = useToast({ position: "top", duration: 3000, status: "success" });
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const roles = useSelector(state => state.roles);
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: data
  });

  return (
    <GModal
      onClose={onClose}
      modalHeader={t("pages.roles.update_role")}
      modalContent={(
        <Box p={4}>
          <form onSubmit={handleSubmit(values => {
            values.IsActive=true
            //values.userId=0
            values.UserId = localStorage.getItem("userId");
            dispatch(updateRole({
              id: values.id,
              values
            }))
              .unwrap()
              .then(_ => {
                toast({ description: t("pages.roles.role_updated") });
                dispatch(getRoles())
                onClose()
              });
          })}>
            <Stack spacing={6}>
              <Input
                label={t("pages.roles.name")}
                labelStyle={{ textTransform: "capitalize" }}
                placeholder={t("pages.roles.name")}
                name="roleName"
                isFormController
                isRequired
                control={control}
              />
              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("general.save")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  isLoading={roles.isLoading}
                  hover={{ color: "primary", borderColor: "primary", bg: "none" }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  isLoading={roles.isLoading}
                  hover={{ color: "red.600", borderColor: "red.600", bg: "none" }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      )}
    />
  )
}

export default UpdateModal